import { render, staticRenderFns } from "./WechatDialog.vue?vue&type=template&id=564b9ce8&scoped=true"
import script from "./WechatDialog.vue?vue&type=script&lang=js"
export * from "./WechatDialog.vue?vue&type=script&lang=js"
import style0 from "./WechatDialog.vue?vue&type=style&index=0&id=564b9ce8&prod&lang=css"
import style1 from "./WechatDialog.vue?vue&type=style&index=1&id=564b9ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b9ce8",
  null
  
)

export default component.exports